import { z } from 'zod';

export const IdSchema = z.string().min(1).max(64);
export const IsoDateSchema = z.string().datetime({ offset: true });

export const UnitsSchema = z.enum(['KG', 'LB']);
export type Units = z.infer<typeof UnitsSchema>;

export const WeekdaySchema = z.enum(['MONDAY', 'SUNDAY']);
export type Weekday = z.infer<typeof WeekdaySchema>;

export const PaginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type Pagination = z.infer<typeof PaginationSchema>;

export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
